"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemperaturePanel = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.number.to-fixed.js");
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _sohneBuchWebfont = _interopRequireDefault(require("paul-core-package/dist/fonts/sohne-buch-webfont.woff"));
var _paulCorePackage = require("paul-core-package");
var _Types = require("../../../Types");
var _constants = require("../../../utils/constants");
var _useGetValue = require("../../../hooks/useGetValue");
var _functions = require("../../../utils/functions");
var _TemperaturePanelBackground = require("../../models/panels/TemperaturePanelBackground");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @todo add in core export fonts */
/** @todo remove absolute path */

const {
  colors
} = _paulCorePackage.constants;
const TemperaturePanel = exports.TemperaturePanel = /*#__PURE__*/(0, _react.memo)(_ref => {
  var _useSelector;
  let {
    position = [0, 0, 0],
    thingPDIDDevice,
    displayNameId
  } = _ref;
  const [temperature, temperatureStatus = {}, unit] = (0, _useGetValue.useGetValueParamsByDisplayNameId)({
    displayNameId,
    thingPDIDDevice,
    params: [_constants.valueParamsName.value, _constants.valueParamsName.temperatureStatus, _constants.valueParamsName.unit]
  });
  const tVUnit = (_useSelector = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues)) === null || _useSelector === void 0 || (_useSelector = _useSelector.Default) === null || _useSelector === void 0 ? void 0 : _useSelector.unit;
  const tUnit = tVUnit ? tVUnit[unit] : '';
  const statusColor = (0, _functions.getStatusColor)({
    statusColor: temperatureStatus.statusColor
  });
  const showTemperature = temperature && temperature <= 100;
  return /*#__PURE__*/_react.default.createElement("group", {
    position: [position[0], position[1] + 2.2, position[2] + 4.6]
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: null
  }, /*#__PURE__*/_react.default.createElement(_TemperaturePanelBackground.TemperaturePanelBackground, {
    position: [-0.01, 0, 0],
    scale: 1.7,
    color: statusColor
  })), /*#__PURE__*/_react.default.createElement("group", {
    position: [0, -0.9955, 0.994],
    rotation: [0, Math.PI / 2, 0]
  }, /*#__PURE__*/_react.default.createElement(_drei.Text, {
    position: [0.5, -0.5, 0.1],
    color: colors['main-color-cl-19'],
    fontSize: 1.8,
    letterSpacing: -0.05,
    lineHeight: 1,
    font: _sohneBuchWebfont.default,
    anchorX: "right",
    anchorY: "middle"
  }, "T")), /*#__PURE__*/_react.default.createElement(_drei.Text, {
    rotation: [0, Math.PI / 2, 0],
    color: colors['main-color-cl-19'],
    fontSize: 3,
    position: [0, -2.5, showTemperature ? -7 : -5.5],
    letterSpacing: -0.05,
    lineHeight: 1,
    font: _sohneBuchWebfont.default,
    anchorX: "right",
    anchorY: "middle",
    outlineBlur: 0.8,
    outlineColor: "black",
    outlineOpacity: 0.4
  }, showTemperature ? "".concat(temperature.toFixed(1)) : '-'), /*#__PURE__*/_react.default.createElement(_drei.Text, {
    visible: showTemperature,
    rotation: [0, Math.PI / 2, 0],
    color: colors['main-color-cl-19'],
    fontSize: 1.5,
    position: [0, -1.825, -9],
    letterSpacing: -0.05,
    lineHeight: 1,
    font: _sohneBuchWebfont.default,
    anchorX: "right",
    anchorY: "middle",
    outlineBlur: 0.8,
    outlineColor: "black",
    outlineOpacity: 0.4
  }, tUnit));
}, (prev, next) => prev.position === next.position && prev.thingPDIDDevice === next.thingPDIDDevice && prev.displayNameId === next.displayNameId);
TemperaturePanel.propTypes = {
  position: _Types.VectorType,
  displayNameId: _propTypes.default.number,
  thingPDIDDevice: _propTypes.default.string
};